type ThemeInterface = typeof defaultTheme;

declare module 'styled-components' {
  interface DefaultTheme extends ThemeInterface {}
}

export const defaultTheme = {
  colors: {
    layout100: '#262626',
    layout90: '#3b3b3b',
    layout80: '#515151',
    layout70: '#7d7d7d',
    layout60: '#b3b3b3',
    layout50: '#d4d4d4',
    layout40: '#e9e9e9',
    layout30: '#f4f4f4',
    brand100: '#ff7000',
    brand100Hover: 'rgba(255,112,0,0.9);',
    brand90: '#ff7e19',
    brand80: '#ff8d33',
    brand70: '#ffa966',
    brand60: '#ffcda6',
    brand50: '#ffe2cc',
    brand40: '#fff0e5',
    brand30: '#fff8f2',
    positive100: '#40cc33',
    positive90: '#53d147',
    positive80: '#66d65c',
    positive70: '#8ce085',
    positive60: '#bcedb8',
    positive50: '#d9f5d6',
    positive40: '#ebf9ea',
    positive30: '#f5fcf5',
    negative100: '#ff0000',
    negative90: '#ff1919',
    negative80: '#ff3333',
    negative70: '#ff6666',
    negative60: '#ffa6a6',
    negative50: '#ffcccc',
    negative40: '#ffe5e5',
    negative30: '#fff2f2',
    action100: '#0080ff',
    action90: '#198cff',
    action80: '#3399ff',
    action70: '#66b3ff',
    action60: '#a6d3ff',
    action50: '#cce6ff',
    action40: '#e5f2ff',
    action30: '#f2f8ff',
    black: '#000000',
    white: '#ffffff',
    // all colors above are from Hoffman Palette
    // all colors below are project specific colors
    customGrey1: '#aab9c4',
    customGrey2: '#f2f2f2',
    customGrey3: '#e2e2e2',
    customGrey4: '#eee',
    customBlueGrey1: '#557289',
    customButtonBorderGrey: '#ccd5dc',
    customButtonBackgroundGrey: 'rgba(221, 227, 231, 0.4)',
    customButtonBackgroundGreyHover: 'rgba(204, 213, 220, 0.4)',
    customButtonGrey: '#557289FF',
    // Configuration state colors
    STATE_CREATED: '#557289',
    STATE_REQUESTED: '#0068d1',
    STATE_OFFER_CREATED: '#d15b00',
    STATE_ARCHIVED: '#666666',
    STATE_DELETED: '#666666',
    STATE_DRAFT: '#666666',
    STATE_ORDERED: '#34a729',
    // Configurator colors
    articleNumber: '#808080',
    sidebarHeaderShadowColor: '#e2e2e2',
    errorColor: '#f00',
    dialogBackgroundColor: 'rgba(0, 0, 0, 0.5)',
    buttonIconColor: 'rgba(38, 38, 38, 0.7)',
    borderColor: '#2626261a',
    attentionColor: '#ffe050',
    environmentColor: '#f7ab09',
    qssEnvironmentColor: '#49ab1d',
    borderLight: 'rgba(38,38,38,0.05)',
  },
};

export type ThemeColors = keyof typeof defaultTheme.colors;
